module.exports = __webpack_public_path__ + "img/frame.d7d280be.png";